import { DashboardMyTaskService } from './../../../services/dashboardmytask.service'
import { Component, OnInit, OnChanges, OnDestroy, Input, ViewChild, ViewChildren, AfterViewInit, Output, EventEmitter, QueryList, ChangeDetectorRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';
import * as _ from 'lodash';
import { CalendarTaskDetailsComponent } from './../calendar-task-details/calendar-task-details.component';
import { NgbDateStruct, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ActivatedTaskFromComplianceService } from './../../../services/activatedTaskFromCompliance.service'
import { UserMasterService } from './../../../services/user-master.service';
import * as moment from 'moment';
import { NotificationComponent } from '../notification/notification.component';
import { Observable } from 'rxjs/Observable';
import { BulkUpdateTaskComponent } from './../bulk-update-task/bulk-update-task.component';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-mytask',
  templateUrl: './mytask.component.html',
  styleUrls: ['./mytask.component.css']
})
export class MytaskComponent implements OnInit, OnChanges, OnDestroy {

  @Input('refreshStatus') refreshStatus: any;
  @Output() UpdatedStatus = new EventEmitter();

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtElement: DataTableDirective;
  dtGovernanceOptions: DataTables.Settings = {};
  dtGovernanceTrigger: Subject<any> = new Subject();

  dtComplianceOptions: DataTables.Settings = {};
  dtComplianceTrigger: Subject<any> = new Subject();

  // dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  // dtTrigger: Subject<any> = new Subject();
  filteredData: any;
  displayLabel: string;


  //my task activites -- 3 Jan
  //display task details
  complianceTaskDetails: any = [];
  complianceTaskDetailsCache: any = [];
  governanceTaskDetails: any = [];
  governanceTaskDetailsCache: any = [];
  myTaskDetails: any = [];
  myTaskDetailsCache: any = [];
  myTaskList: any = [];
  taskObj: any = {
    taskListIds: [],
    taskStatus: ''
  }
  complianceTaskList: any = [];
  complianceTaskObj: any = {
    taskListIds: [],
    taskStatus: ''
  }

  activeComplianceTab: boolean = false;
  isMyTaskFetch: any;
  showDropDown = false;
  loadAllCompanies: boolean = false; // Flag to control loading all companies or just current
  isFetchingTasks: boolean = false; // Flag to prevent concurrent fetches
  taskListCache: any = null; // Cache for task list
  taskListCacheTimestamp: number = 0; // Cache timestamp
  taskListCacheExpiry: number = 30 * 1000; // 30 seconds cache expiry
  private taskSubscription: any = null; // Store subscription to prevent multiple calls
  private complianceSubscription: any = null; // Store compliance subscription separately
  private isProcessingTasks: boolean = false; // Flag to prevent duplicate processing
  constructor(
    private dashboardMyTaskService: DashboardMyTaskService, 
    private modalService: NgbModal, 
    private activatedTaskFromComplianceService: ActivatedTaskFromComplianceService, 
    private userService: UserMasterService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.isMyTaskFetch = localStorage.getItem("isMyTaskFetch");

    if (this.isMyTaskFetch != "false") {
      this.showMyTaskDetails();
      this.dtGovernanceOptions = {
        destroy: true,
        pagingType: 'full_numbers',
        paging: true,
        pageLength: 6,
        order: [1, 'asc'],
        columnDefs: [{ orderable: false, targets: [0] }],
        scrollCollapse: true,
        searching: false,
        lengthChange: false,
        language: { //made changes for datatables for next previous button
          "paginate": {
            "first": "<<",
            "last": ">>",
            "next": ">",
            "previous": "<"
          }
        }
      };

      this.dtComplianceOptions = {
        destroy: true,
        pagingType: 'full_numbers',
        paging: true,
        pageLength: 6,
        order: [1, 'asc'],
        columnDefs: [{ orderable: false, targets: [0] }],
        scrollCollapse: true,
        searching: false,
        lengthChange: false,
        language: { //made changes for datatables for next previous button
          "paginate": {
            "first": "<<",
            "last": ">>",
            "next": ">",
            "previous": "<"
          }
        }
      };
    }
  }

  ngOnChanges(changes: any) {
    // Only refresh if refreshStatus actually changed
    if (changes.refreshStatus && !changes.refreshStatus.firstChange && changes.refreshStatus.currentValue !== changes.refreshStatus.previousValue) {
      this.isMyTaskFetch = localStorage.getItem("isMyTaskFetch");
      if (this.isMyTaskFetch != "false") {
        // Unsubscribe any ongoing requests to prevent multiple calls
        if (this.taskSubscription) {
          this.taskSubscription.unsubscribe();
          this.taskSubscription = null;
        }
        this.isFetchingTasks = false;
        // Clear cache when explicitly refreshed
        this.taskListCache = null;
        this.taskListCacheTimestamp = 0;
        this.showMyTaskDetails();
      }
    }
  }

  showMyTaskDetails() {

    this.displayLabel = "All";
    // this.dtOptions = {
    //   destroy: true,
    //   pagingType: 'full_numbers',
    //   paging: true,
    //   pageLength: 3,
    //   search: true,
    //   lengthChange: false,
    //   language: { //made changes for datatables for next previous button
    //     "paginate": {
    //       "first": "<<",
    //       "last": ">>",
    //       "next": ">",
    //       "previous": "<"
    //     }
    //   }
    // };


    this.myTaskDetails = [];
    this.myTaskDetailsCache = [];
    var loginUsers = JSON.parse(localStorage.getItem("user"));
    let assignedToId = loginUsers._id;
    let companyId = loginUsers.CompanyId;
    let uniqueUesrId = loginUsers.UniqueUserId;
    //console.log("isMyTaskFetch", this.isMyTaskFetch)
    if (assignedToId != "" && this.isMyTaskFetch != "false") {
      this.intializeTaskListOnbehaveOfUniqueUserId(uniqueUesrId, companyId)
    }
  }

  filterTasks(data) {
    this.showDropDown = !this.showDropDown;
    const doc: any = document.getElementById('dropdown-menu')
    if (doc) {
      doc.style.display = 'none';
    }
    this.myTaskDetails = [];


    this.displayLabel = data;
    this.myTaskDetails = _.filter(this.myTaskDetailsCache, function (o) { return o.LocalStatus === data });
    if (data == 'All') {
      this.myTaskDetails = [];
      this.myTaskDetails = this.myTaskDetailsCache;
    } else if (data == 'PartiallyCompleted') {
      this.displayLabel = 'Partially Completed';
    } else if (data == 'DelayedCompletion') {
      this.displayLabel = 'Delayed Completion';
    } else if (data == 'NA') {
      this.displayLabel = 'Not Applicable';
    }

  }

  // Kanban view helper methods
  getPendingTasks() {
    return _.filter(this.myTaskDetailsCache, (task) => {
      return task.LocalStatus === 'Pending' || task.ColorDisplayStatus === 'Pending' || task.ColorDisplayStatus === 'Expired';
    });
  }

  getInProgressTasks() {
    return _.filter(this.myTaskDetailsCache, (task) => {
      return task.LocalStatus === 'PartiallyCompleted' || task.ColorDisplayStatus === 'PartiallyCompleted';
    });
  }

  getCompletedTasks() {
    return _.filter(this.myTaskDetailsCache, (task) => {
      return task.LocalStatus === 'Completed' || task.LocalStatus === 'Done' || task.LocalStatus === 'DelayedCompletion' ||
             task.ColorDisplayStatus === 'Completed' || task.ColorDisplayStatus === 'Done' || task.ColorDisplayStatus === 'DelayedCompletion';
    });
  }

  getClosedTasks() {
    return _.filter(this.myTaskDetailsCache, (task) => {
      return task.LocalStatus === 'Cancelled' || task.LocalStatus === 'NA' ||
             task.ColorDisplayStatus === 'Cancelled' || task.ColorDisplayStatus === 'NA';
    });
  }

  taskDetails(task) {
    //  
    // //console.log('task', task)
    let activatedTaskFromCompliance: boolean
    if (task.ActivatedTaskFromCompliance == undefined) {
      activatedTaskFromCompliance = false;
    } else if (task.ActivatedTaskFromCompliance) {
      activatedTaskFromCompliance = task.ActivatedTaskFromCompliance;
    }
    console.log("activatedTaskFromCompliance------", activatedTaskFromCompliance)
    const modalRef = this.modalService.open(CalendarTaskDetailsComponent, { size: 'lg' })
    modalRef.componentInstance.taskId = { _id: task._id, calendarId: 'myTask', activatedTaskFromCompliance: activatedTaskFromCompliance };
    modalRef.result.then(response => {
      // //console.log('checling for the response', response)
      //this.showMyTaskDetails();
      this.UpdatedStatus.emit(response);
    }, (reason) => {
      // //console.log('checling for the reason', reason)
    })
  }

  //----------//Bulk Update//----------//  
  showGovernanceTasks() {
    $(".gov").val("All");
    $(".govFilter").val("All");
    this.activeComplianceTab = false;
    $("#govTab").addClass("active");
    $("#governanceTab").addClass("active");
    $("#compTab").removeClass("active");
    $("#complianceTab").removeClass("active");
    // this.displayLabel = "All";   


    this.governanceTaskDetails = [];
    this.governanceTaskDetailsCache = [];
    var loginUsers = JSON.parse(localStorage.getItem("user"));
    let assignedToId = loginUsers._id;
    let companyId = loginUsers.CompanyId;
    let uniqueUesrId = loginUsers.UniqueUserId;

    // $('#myTasksTable').DataTable({ destroy: true }).destroy();
    //  
    if (assignedToId != "" && this.isMyTaskFetch != "false") {
      this.dashboardMyTaskService.getUserIdbyUniqueUserId(uniqueUesrId,true).then((responseOfListOfId) => {
        if (!responseOfListOfId.status) {
          var promiseArray = [];
          var compliancePromiseArray = [];
          var self = this;
          for (var index = 0; index < responseOfListOfId.listOfId.length; index++) {
            promiseArray.push(self.dashboardMyTaskService.getMyTaskList(_.get(responseOfListOfId.listOfId[index], '_id')))
            compliancePromiseArray.push(self.activatedTaskFromComplianceService.getMyActivatedTaskList(_.get(responseOfListOfId.listOfId[index], 'CompanyId'), _.get(responseOfListOfId.listOfId[index], '_id')))
        }
        // Only call forkJoin if there are promises
        if (promiseArray.length > 0) {
          Observable.forkJoin(promiseArray).subscribe(multipleCompanyTaskList => {
            let taskList = _.filter(multipleCompanyTaskList, function (element) { return !_.isNil(_.get(element, 'taskList')) })
            let mytaskList = { taskList: [] }
            let tempList = [];
            mytaskList.taskList = _.map(taskList, function (element) { return _.concat(tempList, _.get(element, 'taskList')) })
            mytaskList.taskList = _.flatten(mytaskList.taskList)
            // mytaskList.taskList = _.reduce(taskList, function (currentElement, nextElement) { return _.concat(_.get(currentElement, 'taskList'), _.get(nextElement, 'taskList')) })
            mytaskList.taskList.forEach(task => {
              if (task.Status === "Completed" || task.Status === "Done" || task.Status === "DelayedCompletion") {
                task.LocalStatus = task.Status;
                task.ColorDisplayStatus = task.Status;
              } else {

                var tempEndDate: Date = new Date(task.EndDate);
                var date = tempEndDate.getDate();
                var month = tempEndDate.getMonth();
                var year = tempEndDate.getFullYear();
                var endDate = new Date(year, month, date);

                var tempTodayDate: Date = new Date();
                var dateT = tempTodayDate.getDate();
                var monthT = tempTodayDate.getMonth();
                var yearT = tempTodayDate.getFullYear();
                var todayDate = new Date(yearT, monthT, dateT);


                if (endDate < todayDate) {
                  task.LocalStatus = task.Status;
                  task.ColorDisplayStatus = "Expired";
                } else {
                  task.LocalStatus = task.Status;
                  task.ColorDisplayStatus = task.Status;
                }
              }
            });
            for (var taskIndex = 0; taskIndex < mytaskList.taskList.length; taskIndex++) {
              mytaskList.taskList[taskIndex].isSelected = false;
            }
            //console.log('mytaskList.taskList', mytaskList.taskList)
            this.governanceTaskDetails = mytaskList.taskList;
            this.governanceTaskDetailsCache = mytaskList.taskList;

            if (this.governanceTaskDetails != null || _.size(this.governanceTaskDetails) > 0) {
              this.dtGovernanceTrigger.next();
              this.dtComplianceTrigger.next();
            }
          })
        }
      }}).catch((error) => {
        console.error('Error fetching governance tasks:', error);
      });
    }
  }

  filterGovernaceTasks(data) {
    $('input:checkbox').attr('checked', false);
    $("#checkAll").prop('checked', false);
    this.taskObj.taskStatus = "";
    this.taskObj.taskListIds = [];
    if (data.target.value == 'All') {
      this.governanceTaskDetails = [];
      this.dtElements.forEach((dtElement: DataTableDirective) => {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      });
      this.governanceTaskDetails = this.governanceTaskDetailsCache;
      // this.dtGovernanceTrigger.next();
      if (this.governanceTaskDetails != null || _.size(this.governanceTaskDetails) > 0) {
        this.dtGovernanceTrigger.next();
        this.dtComplianceTrigger.next();
      }
    }
    else {
      this.governanceTaskDetails = [];
      this.dtElements.forEach((dtElement: DataTableDirective) => {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      });
      this.governanceTaskDetails = _.filter(this.governanceTaskDetailsCache, function (o) { return o.LocalStatus === data.target.value });
      // this.dtGovernanceTrigger.next();
      if (this.governanceTaskDetails != null || _.size(this.governanceTaskDetails) > 0) {
        this.dtGovernanceTrigger.next();
        this.dtComplianceTrigger.next();
      }
    }
    // $('#myTasksTable').DataTable({ destroy: true }).destroy();    
  }

  markTasks(event) {
    var taskStatus = event.target.value;
    this.taskObj.taskStatus = taskStatus;
    // this.taskObj.taskListIds = this.myTaskList;
  }

  markAll(event) {
    //console.log('event.target.checked', event.target.checked)
    if (event.target.checked) {
      this.governanceTaskDetails.forEach(element => {
        element.isSelected = true;
      });
    } else {
      this.governanceTaskDetails.forEach(element => {
        element.isSelected = false;
      });
    }

    //  
    // if (event.target.checked == true) {
    //   $('input:checkbox').attr('checked', true);
    //   // $("#input").prop('checked', true);
    //   this.myTaskList = this.governanceTaskDetails.map(function (o) {
    //     return o._id;
    //   })
    //   this.taskObj.taskListIds = this.myTaskList;
    // }
    // else if (event.target.checked == false) {
    //   $('input:checkbox').attr('checked', false);
    //   this.myTaskList = [];
    //   this.taskObj.taskListIds = []
    // }
  }

  showComplianceTasks() {
    $(".comp").val("All");
    $(".compFilter").val("All");
    this.activeComplianceTab = true;
    this.displayLabel = "All";

    this.complianceTaskDetails = [];
    this.complianceTaskDetailsCache = [];
    var loginUsers = JSON.parse(localStorage.getItem("user"));
    let assignedToId = loginUsers._id;
    let companyId = loginUsers.CompanyId;
    let uniqueUesrId = loginUsers.UniqueUserId;

    $('#complianceTasksTable').DataTable({ destroy: true }).destroy();

    if (assignedToId != "" && this.isMyTaskFetch != "false") {

      if (companyId != "") {


        this.dashboardMyTaskService.getUserIdbyUniqueUserId(uniqueUesrId,true).then((responseOfListOfId) => {
          if (!responseOfListOfId.status) {
            var promiseArray = [];
            var compliancePromiseArray = [];
            var self = this;
            for (var index = 0; index < responseOfListOfId.listOfId.length; index++) {
              // promiseArray.push(self.dashboardMyTaskService.getMyTaskList(_.get(responseOfListOfId.listOfId[index], '_id')))
              // compliancePromiseArray.push(self.activatedTaskFromComplianceService.getMyActivatedTaskList(_.get(responseOfListOfId.listOfId[index], 'CompanyId'), _.get(responseOfListOfId.listOfId[index], '_id')))
            }
            self.activatedTaskFromComplianceService.getMyActivatedTaskList(companyId, assignedToId).then(listOfcomplianceTaskList => {
              let removedUndefinedValues = _.filter(listOfcomplianceTaskList, function (element) { return !_.isNil(element) })
              if (_.size(removedUndefinedValues)) {
                let complianceTaskList = _.flattenDeep(removedUndefinedValues)
                complianceTaskList = complianceTaskList.filter(g => _.get(g, 'StartDate') != null && _.get(g, 'StartDate') != undefined && _.get(g, 'EndDate') != undefined && _.get(g, 'EndDate') != null)

                for (let complianceIndex = 0; complianceIndex < complianceTaskList.length; complianceIndex++) {
                  let task = {
                    ActivatedTaskFromCompliance: true,
                    // TaskStatus: "",
                    LocalStatus: "",
                    EndDate: "",
                    ColorDisplayStatus: ""
                  }
                  complianceTaskList[complianceIndex] = _.assign(task, complianceTaskList[complianceIndex])
                  complianceTaskList[complianceIndex].ActivatedTaskFromCompliance = true;

                  switch (_.toInteger(complianceTaskList[complianceIndex].TaskStatus)) {
                    case 1://Pending
                      //console.log('it is coming here')
                      complianceTaskList[complianceIndex].LocalStatus = "Pending";
                      break;
                    case 2://Completed
                      complianceTaskList[complianceIndex].LocalStatus = "Completed";
                      break;
                    case 3://DelayedCompletion
                      complianceTaskList[complianceIndex].LocalStatus = "DelayedCompletion";
                      break;
                    case 4://PartiallyCompleted
                      complianceTaskList[complianceIndex].LocalStatus = "PartiallyCompleted";
                      break;
                    case 5://NA
                      complianceTaskList[complianceIndex].LocalStatus = "NA";
                      break;
                    case 6://Done
                      complianceTaskList[complianceIndex].LocalStatus = "Done";
                      break;
                    case 7://Cancelled
                      complianceTaskList[complianceIndex].LocalStatus = "Cancelled";
                      break;
                    default:
                      break;
                  }
                  if (complianceTaskList[complianceIndex].LocalStatus != "Completed" && complianceTaskList[complianceIndex].LocalStatus != "Done" && complianceTaskList[complianceIndex].LocalStatus != "DelayedCompletion") {
                    //  
                    // var endDate: Date = new Date(Date.parse(task.EndDate));
                    // var todayDate: Date = new Date(Date.parse(Date()));

                    var tempEndDate: Date = new Date(complianceTaskList[complianceIndex].EndDate);
                    var date = tempEndDate.getDate();
                    var month = tempEndDate.getMonth();
                    var year = tempEndDate.getFullYear();
                    var endDate = new Date(year, month, date);

                    var tempTodayDate: Date = new Date();
                    var dateT = tempTodayDate.getDate();
                    var monthT = tempTodayDate.getMonth();
                    var yearT = tempTodayDate.getFullYear();
                    var todayDate = new Date(yearT, monthT, dateT);

                    if (endDate < todayDate) {
                      complianceTaskList[complianceIndex].ColorDisplayStatus = "Expired";
                    } else {
                      complianceTaskList[complianceIndex].ColorDisplayStatus = complianceTaskList[complianceIndex].LocalStatus;
                    }
                  } else {
                    complianceTaskList[complianceIndex].LocalStatus = complianceTaskList[complianceIndex].LocalStatus;
                    complianceTaskList[complianceIndex].ColorDisplayStatus = complianceTaskList[complianceIndex].LocalStatus;
                  }
                }
                this.complianceTaskDetails = complianceTaskList;
                this.complianceTaskDetailsCache = complianceTaskList;

                if (this.governanceTaskDetails != null || _.size(this.governanceTaskDetails) > 0) {
                  this.dtGovernanceTrigger.next();
                  this.dtComplianceTrigger.next();
                }
              }
            })
          }
        })
      }
      // this.dtComplianceTrigger.next();
    }
  }

  markComplianceTasks(event) {

    var taskStatus = event.target.value;
    this.complianceTaskObj.taskStatus = taskStatus;
    //   this.complianceTaskObj.taskListIds = this.complianceTaskList;
  }

  updateStatus() {
    let self = this;
    if (this.activeComplianceTab == false) {
      // Goverance Tab for updating status...
      //console.log('self.governanceTaskDetails', self.governanceTaskDetails)
      let selectedTask = _.filter(self.governanceTaskDetails, function (element) { return element.isSelected })
      //console.log('selectedTask==>', selectedTask)
      _.forEach(self.governanceTaskDetails, function (element) {
        element.isSelected = false;
      })
      return;
      // if (this.taskObj.taskListIds.length != 0) {
      //   if ((this.taskObj.taskStatus != "") && (this.taskObj.taskStatus != "All")) {
      //     this.dashboardMyTaskService.bulkUpdateTaskStatus(this.taskObj).then(response => {
      //        
      //       if (response.status == 0) {
      //         const modalRef = this.modalService.open(NotificationComponent)
      //         modalRef.componentInstance.notify = { status: 'Success', message: 'Tasks Status are updated successfully.' }
      //         this.myTaskList = [];
      //         this.governanceTaskDetails = [];
      //         this.governanceTaskDetailsCache = [];
      //         $('input:checkbox').attr('checked', false);
      //         $("#checkAll").prop('checked', false);
      //         $(".gov").val("All");
      //         this.taskObj.taskStatus = "";
      //         this.taskObj.taskListIds = [];
      //         this.showMyTaskDetails();
      //          
      //         this.dtElements.forEach((dtElement: DataTableDirective) => {
      //            
      //           dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //              
      //             dtInstance.destroy();
      //           });
      //         });
      //         // var datable = $('#myTasksTable').DataTable();
      //         // datable.state.clear();
      //         this.UpdatedStatus.emit(response);
      //       } else {
      //         const modalRef = this.modalService.open(NotificationComponent)
      //         modalRef.componentInstance.notify = { status: 'Failure', message: 'OOPS! Something went wrong.' }
      //         this.myTaskList = [];
      //         this.governanceTaskDetails = [];

      //         $('input:checkbox').attr('checked', false);
      //         $("#checkAll").prop('checked', false);
      //         $(".gov").val("All");
      //         this.taskObj.taskStatus = "";
      //         this.taskObj.taskListIds = [];
      //         this.showMyTaskDetails();
      //         this.dtElements.forEach((dtElement: DataTableDirective) => {
      //           dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //             dtInstance.destroy();
      //           });
      //         });
      //       }
      //     })
      //   }
      //   else {
      //     const modalRef = this.modalService.open(NotificationComponent)
      //     modalRef.componentInstance.notify = { status: 'Failure', message: 'Please select status.' }
      //     this.myTaskList = [];
      //     this.governanceTaskDetails = [];
      //     this.taskObj.taskStatus = "";
      //     this.taskObj.taskListIds = [];
      //     $('input:checkbox').attr('checked', false);
      //     $("#checkAll").prop('checked', false);
      //     // this.showGovernanceTasks();
      //     this.showMyTaskDetails();
      //     this.dtElements.forEach((dtElement: DataTableDirective) => {
      //       dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //         dtInstance.destroy();
      //       });
      //     });
      //   }

      // } else {
      //   const modalRef = this.modalService.open(NotificationComponent)
      //   modalRef.componentInstance.notify = { status: 'Failure', message: 'No tasks can be updated.' }
      //   this.myTaskList = [];
      //   this.governanceTaskDetails = [];
      //   this.taskObj.taskStatus = "";
      //   this.taskObj.taskListIds = [];
      //   $('input:checkbox').attr('checked', false);
      //   $("#checkAll").prop('checked', false);
      //   // this.showGovernanceTasks();
      //   this.showMyTaskDetails();
      //   this.dtElements.forEach((dtElement: DataTableDirective) => {
      //     dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //       dtInstance.destroy();
      //     });
      //   });
      // }
    }
    else {
      // compliance

      if (this.complianceTaskObj.taskListIds.length != 0 && this.isMyTaskFetch != "false") {
        if ((this.complianceTaskObj.taskStatus != "") && (this.complianceTaskObj.taskStatus != "All")) {
          this.dashboardMyTaskService.bulkUpdateTaskStatus(this.complianceTaskObj).then(response => {

            if (response.status == 0) {
              const modalRef = this.modalService.open(NotificationComponent)
              modalRef.componentInstance.notify = { status: 'Success', message: 'Tasks Status are updated successfully.' }
              this.complianceTaskList = [];
              this.complianceTaskDetails = [];
              $('input:checkbox').attr('checked', false);
              $("#checkAllCompliance").prop('checked', false);
            } else {
              const modalRef = this.modalService.open(NotificationComponent)
              modalRef.componentInstance.notify = { status: 'Failure', message: 'OOPS! Something went wrong.' }
              this.complianceTaskList = [];
              this.complianceTaskDetails = [];
              $('input:checkbox').attr('checked', false);
              $("#checkAllCompliance").prop('checked', false);
            }
          })
          $('input:checkbox').attr('checked', false);
          $(".comp").val("All");
          $("#checkAllCompliance").prop('checked', false);
          this.taskObj.taskStatus = "";
          this.showComplianceTasks();
          this.showMyTaskDetails();
        }
        else {
          const modalRef = this.modalService.open(NotificationComponent)
          modalRef.componentInstance.notify = { status: 'Failure', message: 'Please select status.' }
          this.complianceTaskList = [];
          this.complianceTaskDetails = [];
          $('input:checkbox').attr('checked', false);
          $("#checkAllCompliance").prop('checked', false);
          this.showComplianceTasks();
          this.showMyTaskDetails();
        }

      } else

        if (this.complianceTaskObj.taskListIds.length == 0) {
          const modalRef = this.modalService.open(NotificationComponent)
          modalRef.componentInstance.notify = { status: 'Failure', message: 'Tasks Status of Compliance cannot be updated.' }
          this.complianceTaskList = [];
          this.complianceTaskDetails = [];
          $('input:checkbox').attr('checked', false);
          $("#checkAllCompliance").prop('checked', false);
          this.showComplianceTasks();
          this.showMyTaskDetails();
        }
    }

  }

  checkTask(event, task, index) {

    if (!this.governanceTaskDetails[index].isSelected) {
      this.governanceTaskDetails[index].isSelected = true;
    } else {
      this.governanceTaskDetails[index].isSelected = false;
    }
    //console.log('checking for the element', this.governanceTaskDetails[index].isSelected)
    //  
    // if (event.target.checked == true) {
    //   this.myTaskList.push(task._id);
    // } else if (event.target.checked == false) {
    //   this.myTaskList.splice(task._id);
    // }
    // this.taskObj.taskListIds = this.myTaskList;
    //  //console.log("this.myTaskStatusList", this.mytaskList);
  }

  checkComplianceTask(event, task) {

    if (event.target.checked == true) {
      this.complianceTaskList.push(task._id);
    }
    else if (event.target.checked == false) {
      this.complianceTaskList.splice(task._id);
    }
    this.complianceTaskObj.taskListIds = this.complianceTaskList;
    //  //console.log("this.myTaskStatusList", this.mytaskList);
  }

  markAllCompliance(event) {

    if (event.target.checked == true) {
      $('input:checkbox').attr('checked', 'checked');
      // $("#input").prop('checked', true);
      this.complianceTaskList = this.complianceTaskDetails.map(function (o) {
        return o._id;
      })
      this.complianceTaskObj.taskListIds = this.complianceTaskList;
    }
    else if (event.target.checked == false) {
      $('input:checkbox').attr('checked', '');
      this.complianceTaskList = [];
      this.complianceTaskObj.taskListIds = [];
    }
  }

  filterComplianceTasks(data) {

    this.complianceTaskDetails = [];


    //this.displayLabel = data;
    this.complianceTaskDetails = _.filter(this.complianceTaskDetailsCache, function (o) { return o.LocalStatus === data.target.value });
    if (data.target.value == 'All') {
      this.complianceTaskDetails = [];
      this.complianceTaskDetails = this.complianceTaskDetailsCache;
    }
    $('#complianceTasksTable').DataTable({ destroy: true }).destroy();
    //  else if (data == 'PartiallyCompleted') {
    //   this.displayLabel = 'Partially Completed';
    // } else if (data == 'DelayedCompletion') {
    //   this.displayLabel = 'Delayed Completion';
    // } else if (data == 'NA') {
    //   this.displayLabel = 'Not Applicable';
    // }
  }


  intializeTaskListOnbehaveOfUniqueUserId(uniqueUesrId, companyId) {
    // Check cache first - only use cache if it matches the current loadAllCompanies setting
    const now = Date.now();
    if (this.taskListCache && 
        (now - this.taskListCacheTimestamp < this.taskListCacheExpiry) && 
        this.taskListCache.loadAllCompanies === this.loadAllCompanies &&
        this.taskListCache.companyId === companyId) {
      // Use cached data only if it matches current settings
      console.log('Using cached data for', this.loadAllCompanies ? 'all companies' : 'current company');
      this.myTaskDetails = this.taskListCache.myTaskDetails || [];
      this.myTaskDetailsCache = this.taskListCache.myTaskDetailsCache || [];
      return;
    }

    // Prevent concurrent fetches
    if (this.isFetchingTasks) {
      console.log('Already fetching tasks, skipping...');
      return;
    }

    this.isFetchingTasks = true;
    this.dashboardMyTaskService.getUserIdbyUniqueUserId(uniqueUesrId, true).then((responseOfListOfId) => {
      if (!responseOfListOfId.status) {
        var promiseArray = [];
        var compliancePromiseArray = [];
        var self = this;
        
        // Find current company once to reuse - use string comparison to handle type mismatches
        const currentCompany = !this.loadAllCompanies ? _.find(responseOfListOfId.listOfId, (company) => String(company.CompanyId) === String(companyId)) : null;
                
        // Only load all companies if flag is set, otherwise just current company
        if (this.loadAllCompanies) {
          // Load all companies
          for (var index = 0; index < responseOfListOfId.listOfId.length; index++) {
            promiseArray.push(self.dashboardMyTaskService.getMyTaskList(_.get(responseOfListOfId.listOfId[index], '_id')))
          }
          // For activated tasks, call service once with null to get all companies' tasks
          // The service will process all companies when companyId is null/undefined
          compliancePromiseArray.push(self.activatedTaskFromComplianceService.getMyActivatedTaskList(null, null))
        } else {
          // Load only current company
          if (currentCompany) {
            promiseArray.push(self.dashboardMyTaskService.getMyTaskList(currentCompany._id));
            // Pass specific companyId to filter to only that company
            compliancePromiseArray.push(self.activatedTaskFromComplianceService.getMyActivatedTaskList(currentCompany.CompanyId, currentCompany._id));
          } else {
            self.isFetchingTasks = false;
            return;
          }
        }
        // Only call forkJoin if there are promises
        if (promiseArray.length > 0) {
          // Unsubscribe previous subscription if exists to prevent multiple calls
          if (self.taskSubscription) {
            self.taskSubscription.unsubscribe();
            self.taskSubscription = null;
          }
          self.taskSubscription = Observable.forkJoin(promiseArray).subscribe(multipleCompanyTaskList => {
            let taskList = _.filter(multipleCompanyTaskList, function (element) { return !_.isNil(_.get(element, 'taskList')) })
            let mytaskList = { taskList: [] }
            let tempList = [];
            mytaskList.taskList = _.map(taskList, function (element) { return _.concat(tempList, _.get(element, 'taskList')) })
            mytaskList.taskList = _.flatten(mytaskList.taskList)
            
            // Note: When loadAllCompanies is false, we only call getMyTaskList for the current company,
            // so all tasks returned should already be for the current company. No need to filter.
            // The API endpoint filters by assigned user ID which is company-specific.
            
            // mytaskList.taskList = _.reduce(taskList, function (currentElement, nextElement) { return _.concat(_.get(currentElement, 'taskList'), _.get(nextElement, 'taskList')) })
            mytaskList.taskList.forEach(task => {
              let companyObject = _.find(responseOfListOfId.listOfId, function (company) { return task.CompanyId == company.CompanyId })
              if (companyObject) {
                task.CompanyName = companyObject.CompanyName;
              }
              
              // Store the company ID for filtering later if needed
              if (!task.CompanyId && companyObject) {
                task.CompanyId = companyObject.CompanyId;
              }
              if (task.Status === "Completed" || task.Status === "Done" || task.Status === "DelayedCompletion") {
                task.LocalStatus = task.Status;
                task.ColorDisplayStatus = task.Status;
              } else {

                var tempEndDate: Date = new Date(task.EndDate);
                var date = tempEndDate.getDate();
                var month = tempEndDate.getMonth();
                var year = tempEndDate.getFullYear();
                var endDate = new Date(year, month, date);

                var tempTodayDate: Date = new Date();
                var dateT = tempTodayDate.getDate();
                var monthT = tempTodayDate.getMonth();
                var yearT = tempTodayDate.getFullYear();
                var todayDate = new Date(yearT, monthT, dateT);


                if (endDate < todayDate) {
                  task.LocalStatus = task.Status;
                  task.ColorDisplayStatus = "Expired";
                } else {
                  task.LocalStatus = task.Status;
                  task.ColorDisplayStatus = task.Status;
                }
              }
            });
            // this.myTaskDetails = mytaskList.taskList;
            // this.myTaskDetailsCache = mytaskList.taskList;

            // Load compliance tasks - only for current company if not loading all companies
            if (companyId != "") {
              if (self.loadAllCompanies && compliancePromiseArray.length > 0) {
                // Load all companies' compliance tasks
                // Unsubscribe previous compliance subscription if exists
                if (self.complianceSubscription) {
                  self.complianceSubscription.unsubscribe();
                  self.complianceSubscription = null;
                }
                self.complianceSubscription = Observable.forkJoin(compliancePromiseArray).subscribe(
                  (allComplianceTasks) => {
                    self.processComplianceTasks(allComplianceTasks, mytaskList, companyId, uniqueUesrId);
                    self.complianceSubscription = null;
                  },
                  (error) => {
                    self.processComplianceTasks([], mytaskList, companyId, uniqueUesrId);
                    self.complianceSubscription = null;
                  }
                );
              } else if (!self.loadAllCompanies) {
                // Load only current company's compliance tasks - use the currentCompany user ID
                if (currentCompany) {
                  self.activatedTaskFromComplianceService.getMyActivatedTaskList(currentCompany.CompanyId, currentCompany._id).then(listOfcomplianceTaskList => {
                    self.processComplianceTasks([listOfcomplianceTaskList], mytaskList, companyId, uniqueUesrId);
                  }).catch((error) => {
                    self.processComplianceTasks([], mytaskList, companyId, uniqueUesrId);
                  });
                } else {
                  // No current company found, just process governance tasks
                  self.processComplianceTasks([], mytaskList, companyId, uniqueUesrId);
                }
              } else {
                // Should not reach here, but if we do, just process governance tasks
                self.processComplianceTasks([], mytaskList, companyId, uniqueUesrId);
              }
            } else {
              // No company ID, just process governance tasks
              self.processComplianceTasks([], mytaskList, companyId, uniqueUesrId);
            }
          }, (error) => {
            console.error('Error loading governance tasks:', error);
            self.isFetchingTasks = false;
          });
          // Handle case when there are no governance tasks to load
          // Note: This should only happen if promiseArray was empty, meaning no governance tasks
          // But compliance tasks should already be handled in the forkJoin callback above
          if (promiseArray.length === 0) {
            // If no governance tasks, we still need to load compliance tasks if applicable
            if (companyId != "" && currentCompany && !self.loadAllCompanies) {
              // Only load compliance tasks if no governance tasks and we have a current company
              self.activatedTaskFromComplianceService.getMyActivatedTaskList(currentCompany.CompanyId, currentCompany._id).then(listOfcomplianceTaskList => {
                self.processComplianceTasks([listOfcomplianceTaskList], { taskList: [] }, companyId, uniqueUesrId);
              }).catch((error) => {
                self.processComplianceTasks([], { taskList: [] }, companyId, uniqueUesrId);
              });
            } else {
              // No tasks at all
              self.isFetchingTasks = false;
            }
          }
        }
      } else {
        self.isFetchingTasks = false;
      }
    }).catch((error) => {
      const self = this;
      self.isFetchingTasks = false;
      self.isProcessingTasks = false;
    });
  }

  processComplianceTasks(complianceTaskLists: any[], mytaskList: any, companyId: string, uniqueUesrId: string) {
    const self = this;
    
    // Prevent duplicate processing - use a unique key based on the data
    const processingKey = `${self.loadAllCompanies ? 'all' : 'current'}-${companyId}-${Date.now()}`;
    if (self.isProcessingTasks) {
      console.log('Already processing tasks, skipping duplicate call to processComplianceTasks');
      return;
    }
    
    self.isProcessingTasks = true;
    
    // Process compliance task lists - handle API response format
    // getMyActivatedTaskList service returns a flat array of tasks directly (not wrapped in object)
    // When loadAllCompanies=true: forkJoin returns array of responses [[tasks1], [tasks2], ...]
    // When loadAllCompanies=false: we wrap single response in array [[tasks]]
    let complianceTaskList = [];
    
    complianceTaskLists.forEach((response, index) => {
      if (!response) {
        return;
      }
            
      // Check if response has taskList property (API response format)
      if (response.taskList && Array.isArray(response.taskList)) {
        complianceTaskList = complianceTaskList.concat(response.taskList);
      } else if (Array.isArray(response)) {
        // Check if it's array of tasks or array of arrays
        if (response.length > 0 && Array.isArray(response[0])) {
          // Array of arrays - flatten it
          response.forEach((arr, arrIndex) => {
            if (Array.isArray(arr)) {
              complianceTaskList = complianceTaskList.concat(arr);
            } else if (arr && arr.taskList && Array.isArray(arr.taskList)) {
              complianceTaskList = complianceTaskList.concat(arr.taskList);
            }
          });
        } else {
          // It's already an array of tasks (flat array)
          complianceTaskList = complianceTaskList.concat(response);
        }
      } else if (response.status === 'Success' && response.taskList) {
        // Handle nested response format
        complianceTaskList = complianceTaskList.concat(response.taskList);
      } else if (response.status === 0 && response.taskList && Array.isArray(response.taskList)) {
        complianceTaskList = complianceTaskList.concat(response.taskList);
      } 
    });
    
    
    if (_.size(complianceTaskList)) {
      // For activated tasks, don't filter by date - show all activated tasks like in Activated Task Kanban View
      // Only filter out tasks that are completely invalid (no basic task info)
      // Remove date requirement for activated tasks to match Activated Task Kanban View behavior
      complianceTaskList = complianceTaskList.filter(g => {
        // Keep task if it has basic required fields (at least TaskName or TaskParticulars)
        const hasTaskInfo = _.get(g, 'TaskName') || _.get(g, 'TaskParticulars') || _.get(g, 'TaskID') || _.get(g, '_id');
        return hasTaskInfo;
      });
      
      // Filter by company if only loading current company
      if (!self.loadAllCompanies && companyId) {
        const beforeCompanyFilter = complianceTaskList.length;
        const currentCompanyIdStr = String(companyId);
        complianceTaskList = complianceTaskList.filter(task => {
          // Try multiple possible CompanyId field names
          const taskCompanyId = _.get(task, 'CompanyId') || _.get(task, 'companyId') || _.get(task, 'CompanyID') || _.get(task, 'companyID');
          if (!taskCompanyId) {
            // If no CompanyId, we can't filter it - might be from current company
            // But to be safe, exclude it if we're filtering
            return false;
          }
          const taskCompanyIdStr = String(taskCompanyId);
          const matches = taskCompanyIdStr === currentCompanyIdStr;
         
          return matches;
        });
      }
      
      // Note: When loadAllCompanies is false, we only call getMyActivatedTaskList for the current company,
      // so all compliance tasks returned should already be for the current company. No need to filter.
      // The API endpoint /activatedTaskListByAssignedUser/:CompanyID/:AssignedUserID already filters by company.

      let compliancetaskArray = [];
      for (let complianceIndex = 0; complianceIndex < complianceTaskList.length; complianceIndex++) {
        let task = {
          ActivatedTaskFromCompliance: true,
          // TaskStatus: "",
          LocalStatus: "",
          EndDate: "",
          ColorDisplayStatus: ""
        }
        task = _.assign(task, complianceTaskList[complianceIndex])
        // task.ActivatedTaskFromCompliance = true;

        switch (_.toString(_.get(complianceTaskList[complianceIndex], 'TaskStatus'))) {
          case '1'://Pending
            task.LocalStatus = "Pending";
            break;
          case '2'://Completed
            task.LocalStatus = "Completed";
            break;
          case '3'://DelayedCompletion
            task.LocalStatus = "DelayedCompletion";
            break;
          case '4'://PartiallyCompleted
            task.LocalStatus = "PartiallyCompleted";
            break;
          case '5'://NA
            task.LocalStatus = "NA";
            break;
          case '6'://Done
            task.LocalStatus = "Done";
            break;
          case '7'://Cancelled
            task.LocalStatus = "Cancelled";
            break;
          default:
            break;
        }
        if (task.LocalStatus != "Completed" && task.LocalStatus != "Done" && task.LocalStatus != "DelayedCompletion") {

          // var endDate: Date = new Date(Date.parse(task.EndDate));
          // var todayDate: Date = new Date(Date.parse(Date()));

          var tempEndDate: Date = new Date(task.EndDate);
          var date = tempEndDate.getDate();
          var month = tempEndDate.getMonth();
          var year = tempEndDate.getFullYear();
          var endDate = new Date(year, month, date);

          var tempTodayDate: Date = new Date();
          var dateT = tempTodayDate.getDate();
          var monthT = tempTodayDate.getMonth();
          var yearT = tempTodayDate.getFullYear();
          var todayDate = new Date(yearT, monthT, dateT);

          if (endDate < todayDate) {
            task.ColorDisplayStatus = "Expired";
          } else {
            task.ColorDisplayStatus = task.LocalStatus;
          }
        } else {
          task.LocalStatus = task.LocalStatus;
          task.ColorDisplayStatus = task.LocalStatus;
        }
        compliancetaskArray.push(task)
      }
      //console.log('compliancetaskArray', compliancetaskArray)
      //console.log('this.myTaskDetails=>', this.myTaskDetails)
      // Clear and set tasks - ALWAYS start fresh to prevent duplicates
      // Use spread operator to create new arrays, not references
      let governanceTasks = [...mytaskList.taskList];
      let complianceTasks = [...compliancetaskArray];
      
      // Filter by company if only loading current company
      // When loadAllCompanies = false, we should only show tasks from the current company
      // When loadAllCompanies = true, show tasks from all companies (no filtering)
      if (!self.loadAllCompanies && companyId) {
        const beforeGovFilter = governanceTasks.length;
        const beforeCompFilter = complianceTasks.length;
        const currentCompanyIdStr = String(companyId);
                
        // Filter governance tasks by company
        governanceTasks = governanceTasks.filter(task => {
          const taskCompanyId = task.CompanyId || task.companyId || task.CompanyID || task.companyID;
          if (!taskCompanyId) {
            return false; // Exclude tasks without CompanyId when filtering
          }
          const matches = String(taskCompanyId) === currentCompanyIdStr;
          
          return matches;
        });
        
        // Filter compliance tasks by company
        complianceTasks = complianceTasks.filter(task => {
          const taskCompanyId = _.get(task, 'CompanyId') || _.get(task, 'companyId') || _.get(task, 'CompanyID') || _.get(task, 'companyID');
          if (!taskCompanyId) {
            return false; // Exclude tasks without CompanyId when filtering
          }
          const matches = String(taskCompanyId) === currentCompanyIdStr;
          
          return matches;
        });
        
      } 
      
      // Deduplicate tasks by creating a unique key (TaskID or _id)
      // This prevents the same task from appearing multiple times
      const seenTaskIds = new Set();
      governanceTasks = governanceTasks.filter(task => {
        const taskId = task._id || task.TaskID || task.ID || (task.CompanyId + '_' + task.TaskName + '_' + task.EndDate);
        if (seenTaskIds.has(taskId)) {
          return false;
        }
        seenTaskIds.add(taskId);
        return true;
      });
      
      complianceTasks = complianceTasks.filter(task => {
        // Use a more robust unique identifier for compliance tasks
        const taskId = task._id || task.TaskID || task.ID || task.ActivatedTaskId || 
                      (task.CompanyId + '_' + (task.TaskName || task.TaskParticulars || '') + '_' + (task.EndDate || ''));
        if (seenTaskIds.has(taskId)) {
          return false; // Duplicate task
        }
        seenTaskIds.add(taskId);
        return true;
      });
      
      // When loadAllCompanies is false, we've filtered by company above
      // When loadAllCompanies is true, we want all tasks from all companies (deduplicated)
      this.myTaskDetails = [...governanceTasks, ...complianceTasks];
      this.myTaskDetailsCache = [...governanceTasks, ...complianceTasks];
            
      if (this.myTaskDetailsCache.length > 0) {
        // Count by status for debugging
        const statusBreakdown = {
          Pending: this.myTaskDetailsCache.filter(t => t.LocalStatus === 'Pending' || t.ColorDisplayStatus === 'Pending' || t.ColorDisplayStatus === 'Expired').length,
          PartiallyCompleted: this.myTaskDetailsCache.filter(t => t.LocalStatus === 'PartiallyCompleted' || t.ColorDisplayStatus === 'PartiallyCompleted').length,
          Completed: this.myTaskDetailsCache.filter(t => t.LocalStatus === 'Completed' || t.ColorDisplayStatus === 'Completed').length,
          Done: this.myTaskDetailsCache.filter(t => t.LocalStatus === 'Done' || t.ColorDisplayStatus === 'Done').length,
          DelayedCompletion: this.myTaskDetailsCache.filter(t => t.LocalStatus === 'DelayedCompletion' || t.ColorDisplayStatus === 'DelayedCompletion').length,
          Cancelled: this.myTaskDetailsCache.filter(t => t.LocalStatus === 'Cancelled' || t.ColorDisplayStatus === 'Cancelled').length,
          NA: this.myTaskDetailsCache.filter(t => t.LocalStatus === 'NA' || t.ColorDisplayStatus === 'NA').length
        };
      } 
      
      // Force change detection
      self.cdr.detectChanges();
      // this.myTaskDetailsCache = this.myTaskDetailsCache.concat(complianceTaskList);
    } else {
      // No compliance tasks, just governance tasks
      let governanceTasks = [...mytaskList.taskList];
      
      // Filter by company if only loading current company
      if (!self.loadAllCompanies && companyId) {
        const beforeFilter = governanceTasks.length;
        const currentCompanyIdStr = String(companyId);
        governanceTasks = governanceTasks.filter(task => {
          const taskCompanyId = task.CompanyId || task.companyId || task.CompanyID || task.companyID;
          if (!taskCompanyId) {
            return false; // Exclude tasks without CompanyId when filtering
          }
          return String(taskCompanyId) === currentCompanyIdStr;
        });
      }
      
      this.myTaskDetails = governanceTasks;
      this.myTaskDetailsCache = governanceTasks;
    }
    
    // Update cache with metadata to ensure cache matches the loadAllCompanies setting
    var loginUsers = JSON.parse(localStorage.getItem("user"));
    let currentCompanyId = loginUsers ? loginUsers.CompanyId : '';
    self.taskListCache = {
      myTaskDetails: self.myTaskDetails,
      myTaskDetailsCache: self.myTaskDetailsCache,
      loadAllCompanies: self.loadAllCompanies, // Store the flag in cache
      companyId: currentCompanyId // Store company ID to ensure cache matches
    };
    self.taskListCacheTimestamp = Date.now();
    self.isFetchingTasks = false;
    // Reset processing flag immediately - the guard at the start of the method will prevent re-entry
    self.isProcessingTasks = false;
    
    // Force change detection to update UI
    self.cdr.detectChanges();
  }

  setLoadAllCompanies(value: boolean) {
    if (this.loadAllCompanies !== value) {
      this.toggleLoadAllCompanies();
    }
  }

  toggleLoadAllCompanies() {
    
    // Unsubscribe any ongoing requests to prevent multiple calls
    if (this.taskSubscription) {
      this.taskSubscription.unsubscribe();
      this.taskSubscription = null;
    }
    if (this.complianceSubscription) {
      this.complianceSubscription.unsubscribe();
      this.complianceSubscription = null;
    }
    
    // Reset fetching and processing flags
    this.isFetchingTasks = false;
    this.isProcessingTasks = false;
    
    this.loadAllCompanies = !this.loadAllCompanies;
    // Clear cache when toggling to ensure fresh data
    this.taskListCache = null;
    this.taskListCacheTimestamp = 0;
    // Clear current task lists immediately to update UI
    this.myTaskDetails = [];
    this.myTaskDetailsCache = [];
    
    // Force UI update
    this.cdr.detectChanges();
    
    // Reload tasks immediately - no delay needed, the isFetchingTasks flag will prevent multiple calls
    var loginUsers = JSON.parse(localStorage.getItem("user"));
    let companyId = loginUsers.CompanyId;
    let uniqueUesrId = loginUsers.UniqueUserId;
    this.intializeTaskListOnbehaveOfUniqueUserId(uniqueUesrId, companyId);
  }

  bulkUpdateModal($event) {
    const modalRef = this.modalService.open(BulkUpdateTaskComponent, {
      size: 'lg',
      windowClass: 'bulkUpdateModal',
      backdrop: 'static'
    })
    modalRef.result.then((responseOfModal) => {
      if (!responseOfModal.status) {
        const modalRefNotification = this.modalService.open(NotificationComponent)
        modalRefNotification.componentInstance.notify = { status: 'Success', message: 'Tasks Status are updated successfully.' }
        this.showMyTaskDetails();
        this.UpdatedStatus.emit(responseOfModal);
      } else {
        const modalRefNotification = this.modalService.open(NotificationComponent)
        modalRefNotification.componentInstance.notify = { status: 'Failure', message: responseOfModal.message }
      }
    }, (reason) => {
      //console.log(reason)
    })
  }

  ngOnDestroy() {
    // Clean up subscriptions to prevent memory leaks and multiple calls
    if (this.taskSubscription) {
      this.taskSubscription.unsubscribe();
      this.taskSubscription = null;
    }
    if (this.complianceSubscription) {
      this.complianceSubscription.unsubscribe();
      this.complianceSubscription = null;
    }
  }

}
